import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useAtom } from "jotai";
import { systemsAtom, systemsLoadingAtom } from "../atoms/systemsAtom";
import { dashboardViewModeAtom, searchTextAtom, statusFilterAtom } from "../atoms/dashboardViewAtom";
import { systemsApi } from "../service/systemsApi";
import { dashboardApi } from "../service/dashboardApi";
import { SummaryBar } from "../components/SummaryBar";
import { SystemGrid } from "../components/SystemGrid";
import { SystemTable } from "../components/SystemTable";
import { SystemFormModal } from "../components/SystemFormModal";
import styles from "./DashboardPage.module.scss";
export function DashboardPage() {
    const [systems, setSystems] = useAtom(systemsAtom);
    const [loading, setLoading] = useAtom(systemsLoadingAtom);
    const [viewMode, setViewMode] = useAtom(dashboardViewModeAtom);
    const [searchText, setSearchText] = useAtom(searchTextAtom);
    const [statusFilter, setStatusFilter] = useAtom(statusFilterAtom);
    const [summary, setSummary] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const loadSystems = useCallback(async () => {
        setLoading(true);
        const [list, summaryResult] = await Promise.all([systemsApi.list(), dashboardApi.summary()]);
        setSystems(list);
        setSummary(summaryResult);
        setLoading(false);
    }, [setLoading, setSystems]);
    useEffect(() => {
        loadSystems();
    }, [loadSystems]);
    const filteredSystems = useMemo(() => {
        const search = searchText.trim().toLowerCase();
        return systems.filter((system) => {
            const matchesSearch = search.length === 0 ||
                system.name.toLowerCase().includes(search) ||
                system.tags.some((tag) => tag.toLowerCase().includes(search));
            const matchesStatus = statusFilter === "all" || system.currentStatus === statusFilter;
            return matchesSearch && matchesStatus;
        });
    }, [systems, searchText, statusFilter]);
    async function handleCreate(payload) {
        await systemsApi.create(payload);
        setShowForm(false);
        await loadSystems();
    }
    return (_jsxs("div", { className: styles.page, children: [_jsx(SummaryBar, { summary: summary }), _jsxs("div", { className: styles.toolbar, children: [_jsx("input", { className: styles.search, placeholder: "S\u00F6k namn eller tagg\u2026", value: searchText, onChange: (e) => setSearchText(e.target.value) }), _jsxs("select", { value: statusFilter, onChange: (e) => setStatusFilter(e.target.value), children: [_jsx("option", { value: "all", children: "Alla statusar" }), _jsx("option", { value: "Up", children: "Uppe" }), _jsx("option", { value: "Down", children: "Nere" }), _jsx("option", { value: "Unknown", children: "Ok\u00E4nt" })] }), _jsxs("div", { className: styles.viewToggle, children: [_jsx("button", { type: "button", className: viewMode === "grid" ? styles.active : undefined, onClick: () => setViewMode("grid"), children: "Kort" }), _jsx("button", { type: "button", className: viewMode === "table" ? styles.active : undefined, onClick: () => setViewMode("table"), children: "Tabell" })] }), _jsx("button", { type: "button", className: styles.addButton, onClick: () => setShowForm(true), children: "+ Registrera system" })] }), loading ? (_jsx("p", { className: styles.loading, children: "Laddar system\u2026" })) : viewMode === "grid" ? (_jsx(SystemGrid, { systems: filteredSystems })) : (_jsx(SystemTable, { systems: filteredSystems })), showForm && _jsx(SystemFormModal, { onSubmit: handleCreate, onClose: () => setShowForm(false) })] }));
}
